import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const VpnMissing = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Result
        status="warning"
        title={t('vpnNotConnected')}
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            {t('reload') as string}
          </Button>
        }
      />
    </Container>
  );
};
